import { CloseOutlined } from '@ant-design/icons';
import { t } from '@lingui/macro';
import { Button } from 'antd';
import React, { useContext } from 'react';
import BukkuTooltip from '../../Tooltip';
import { UploadLightboxFileManagerContext } from '../context';

export function DeleteButton() {
    const { states, setStates, props } = useContext(UploadLightboxFileManagerContext);
    const {fileUrl} = states;
    const { setFileUrl, setComponentFile } = setStates;
    const {
        //antd
        onChange,
        // parent
        disabled,
    } = props;

    const handleDelete = () => {
        if (onChange) // Using built-in Antd's Form.Item
            onChange(null);

        setFileUrl(null);
        setComponentFile(null);
    };

    if (fileUrl && !disabled) {
        return (
            <BukkuTooltip title={t`Remove`}>
                <Button
                    className="delete-btn"
                    size="small"
                    type="primary"
                    shape="circle"
                    icon={<CloseOutlined />}
                    onClick={handleDelete}
                />
            </BukkuTooltip>
        );
    }
    return null;
}
